<template>
  <div class="content-wrapper">
    <div class="container-lg">
      <div class="row mb-12">
        <div class="col">
          <div class="page-title-nav row">
            <div class="col-2 col-lg-3">
              <router-link
                                :to="`/sakha`"
                                class="btn btn-outline-secondary btn-custom btn-back">
                                <i
                                    class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                                    class="d-none d-lg-block ms-2">ย้อนกลับ</span>
                            </router-link>
            </div>
            <div class="col-8 col-lg-6">
              <h1 class="page-title">สมัครสมาชิก</h1>
            </div>
            <div class="col-12 col-lg-3">
              <a href="#" class="btn btn-primary btn-custom d-none"><i
                  class="fa-icon fa-regular fa-home"></i><span>button</span></a>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6 offset-lg-3">
              <div class="content-card">
                <div class="content-card-title">
                  <i class="fa-icon fa-regular fa-pen-swirl me-2"></i>สมัครสมาชิก
                </div>
                <div class="content-card-body">
                  <h5>เงื่อนไขการสมัคร</h5>
                  <ul>
                    <li>เบอร์โทรศัพท์ของท่านจะเป็นรหัสผู้ใช้งานและรหัสผ่านของท่าน
                      ท่านสามารถเปลี่ยนรหัสผ่านได้ภายหลัง</li>
                    <li>เบอร์โทรศัพท์ต้องเป็นเบอร์ที่สามารถติดต่อได้</li>
                    <li>เบอร์โทรศัพท์ 1 เบอร์ สามารถสมัครได้เพียงครั้งเดียว</li>
                    <li>บัญชีที่ใช้ฝาก-ถอน ต้องเป็นบัญชีเดียวกันเท่านั้น</li>
                    <li>ข้อมูลธนาคารไม่สามารถแก้ไขได้ภายหลัง</li>
                  </ul>
                  <label class="form-label">
                    <h5 class="mb-0">สร้างบัญชี</h5>
                  </label>
                  <hr>
                  <div class="row form-special m-0" v-if="!smsVerified">
                    <label class="form-label">เบอร์โทรศัพท์</label>
                    <div class="input-group input-group-sm input-group-merge" id="phone">
                      <span class="input-group-text"><i class="fa-icon fa-regular fa-mobile"></i></span>
                      <input type="text" class="form-control" maxlength="10" name="mobile" pattern="\d*"
                        placeholder="เบอร์โทรศัพท์ 10 หลัก" v-model="mobile" />
                    </div>
                  </div>
                  <div class="row form-special m-0" v-if="smsVerified">
                    <div class="mb-4">
                      <label class="form-label">ชื่อผู้ใช้งาน</label>
                      <div class="input-group input-group-sm input-group-merge">
                        <span class="input-group-text"><i class="fa-icon fa-regular fa-money-check"></i></span>
                        <input type="text" class="form-control " name="username"
                          placeholder="username (0-9,a-z)" v-model.trim="$v.username.$model" required />
                      </div>
                      <span id="username_text"></span>
                    </div>
                    <div class="mb-4">
                      <label class="form-label">รหัสผ่าน</label>
                      <div class="input-group input-group-sm input-group-merge">
                        <span class="input-group-text"><i class="fa-icon fa-regular fa-money-check"></i></span>
                        <input type="password" class="form-control " name="password" id="password_val"
                          placeholder="password" v-model.trim="$v.password.$model" required />
                        </div>
                        <span id="password_text"></span>
                    </div>
                    <div class="mb-4">
                      <label class="form-label">ยืนยันรหัสผ่าน</label>
                      <div class="input-group input-group-sm input-group-merge">
                        <span class="input-group-text"><i class="fa-icon fa-regular fa-money-check"></i></span>
                        <input type="password" class="form-control " name="repassword" id="repassword_val"
                          placeholder="กรอก password อีกครั้ง" v-model.trim="$v.password_confirmation.$model"
                          required />
                        </div>
                        <span id="password_text"></span>
                    </div>
                    <div class="mb-4" v-if="this.promotion_enable">
                      <label class="form-label">โปรโมชั่น</label>
                      <div class="input-group input-group-sm input-group-merge">
                        <span class="input-group-text"><i class="fa-icon fa-regular fa-money-check"></i></span>
                        <select v-if="this.promotion_enable" class="form-control " name="show_promotion"
                          v-model="promotoion_id">
                          <option value="0">-</option>
                          <option :value="item.id" v-for="(item, index) in getAgentPromotionsRegister"
                            v-bind:key="index">{{ item.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <br>
                  <div class="d-grid">
                    <div class="row" v-if="!smsVerified">
                      <div class="col-12">
                        <button @click="onVerifyOtp" class="btn btn-primary btn-xl btn-block">สมัครสมาชิก</button>
                      </div>
                    </div>
                    <div class="row" v-if="smsVerified">
                      <div class="col-6">
                        <button @click="onCancelRegister"
                          class="btn btn-outline-secondary btn-xl btn-block">ยกเลิก</button>
                      </div>
                      <div class="col-6">
                        <button @click="onSubmitRegister" class="btn btn-primary btn-xl btn-block">ยืนยัน</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="push"></div>
    </div>
    <app-register_success :user="username" :pass="password" />
  </div>
</template>
<style lang="less">
.btn-block {
  display: block !important;
  width: 100% !important;
}
</style>
<script>
import register_success from '@/components/register_success'
import { mapActions, mapState, mapGetters } from 'vuex'
import { checkSpecialChar } from '@/utils/string'
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'Home',
  components: {
    'app-register_success': register_success
  },
  data () {
    return {
      mobile: '',
      // Step 2
      smsotp: '',
      smsVerified: false,
      showGuideOTP: false,
      username: '',
      password: '',
      password_confirmation: '',
      casinoEnable: false,
      indexNews: 0,
      modalLoginShow: false,
      headerBgVariant: 'bgModalHeaderLogin',
      headerTextVariant: 'dark',
      bodyBgVariant: 'primary-login',
      bodyTextVariant: 'dark',
      footerBgVariant: 'dark',
      footerTextVariant: 'dark',
      member_username: null,
      member_password: null,
      promotion_enable: process.env.VUE_APP_PROMOTION_ENABLE,
      promotoion_id: 0
    }
  },
  created () {
    const afKey = this.$route.params.id ? this.$route.params.id : ''
    const agKey = this.$route.params.userAg ? this.$route.params.userAg : ''
    console.log('create regis')
    console.log(afKey)
    console.log(agKey)
    if (!this.isMember) {
      console.log('!this.isMember')
      this.setAfKey(afKey)
      this.setAgKey(agKey)
    }
    // this.$router.replace('/')
  },
  computed: {
    ...mapState({
      afKey: (state) => state.registerModule.afKey,
      agKey: (state) => state.registerModule.agKey
    }),
    ...mapGetters(['getAgentPromotionsRegister', 'getPermisstionRegister'])
  },
  mounted () {
    console.log('afKey =' + this.afKey)
    console.log('agKey =' + this.agKey)
    console.log('LOCK_REG_AG =' + process.env.VUE_APP_LOCK_REG_AG)
    const ag = (process.env.VUE_APP_LOCK_REG_AG ? process.env.VUE_APP_AG_USER : (this.agKey ?? process.env.VUE_APP_AG_USER))
    console.log('real agKey =' + process.env.VUE_APP_LOCK_REG_AG, process.env.VUE_APP_AG_USER, ag)
    // this.clearAfKey()
    // console.log('afKey =' + this.afKey)
  },
  methods: {
    ...mapActions(['setAfKey', 'setAgKey', 'registerCreateUser', 'setLoading', 'reqConfig', 'registerVerifyOtp', 'clearAfKey', 'clearAgKey', 'registerCreateUser', 'setLoading', 'loginAction', 'openErrorPopup', 'openInfoPopup', 'requestUsername', 'getMyAccountBanks', 'getUserInfo', 'getPromotionsList', 'registerSendOTP']),
    openLine () {
      window.open(this.getAgentNews.link)
    },
    async login () {
      if (!this.member_username && !this.member_password) {
        return false
      } else {
        this.setLoading(true)
        const isSucces = await this.loginAction({
          username: this.member_username,
          password: this.member_password
        })
        if (isSucces) {
          this.setLoading(false)
          this.$router.replace('/member/home')
          this.modalLoginShow = false
          this.member_username = null
          this.member_password = null
          this.requestUsername()
          this.getMyAccountBanks()
          this.getUserInfo()
          this.getPromotionsList()
          this.reqConfig(process.env.VUE_APP_AG_ID)
          // window.location.reload()
        } else {
          this.setLoading(false)
          this.$refs.loginform.reset()
          return false
        }
      }
    },
    onCancelRegister () {
      this.smsVerified = false
    },
    async onVerifyOtp () {
      this.smsVerified = true
    },
    async sendSms () {
      const isSucces = await this.registerSendOTP({
        mobile: this.mobile
      })
      if (isSucces) {
        this.showGuideOTP = true
        this.openInfoPopup('ระบบส่ง SMS ไปแล้ว เช็คข้อความบนมือถือของคุณ')
      }
    },
    async onSubmitRegister () {
      this.setLoading(true)
      this.submited = true
      this.$v.$touch()
      if (this.$v.$pending || this.$v.$error) {
        window.scrollTo(0, 0)
        this.openErrorPopup('กรุณากรอกข้อมูลให้เรียบร้อย')
        this.setLoading(false)
      } else {
        console.log({
          username: this.username,
          password: this.password,
          password_confirmation: this.password_confirmation,
          af: this.afKey ? this.afKey : '',
          ag: (process.env.VUE_APP_LOCK_REG_AG ? process.env.VUE_APP_AG_USER : (this.agKey ?? process.env.VUE_APP_AG_USER)),
          mobile: this.mobile,
          otp: this.smsotp,
          promotoion_id: this.promotoion_id
        })
        const isSucces = await this.registerCreateUser({
          username: this.username,
          password: this.password,
          password_confirmation: this.password_confirmation,
          af: this.afKey ? this.afKey : '',
          ag: (process.env.VUE_APP_LOCK_REG_AG ? process.env.VUE_APP_AG_USER : (this.agKey ?? process.env.VUE_APP_AG_USER)),
          mobile: this.mobile,
          otp: this.smsotp,
          promotoion_id: this.promotoion_id
        })

        if (isSucces) {
          this.clearAfKey()
          this.clearAgKey()
          const isSucces = await this.loginAction({
            username: this.username,
            password: this.password
          })
          if (isSucces) {
            this.setLoading(false)
            this.submited = false
            this.requestUsername()
            this.reqConfig(process.env.VUE_APP_AG_ID)
            // this.$bvModal.hide('modal-user-register')
            // this.$bvModal.hide('modal-user-login')
            this.$bvModal.show('modal-user-register_success')
            // this.$router.replace('/member/settings/bank/add')
            // this.$router.replace('/register-success')
          }
        } else {
          this.setLoading(false)
          this.submited = false
          return false
        }
      }
    },
    openLogin () {
      // this.$router.replace('/register-verify')
      this.$bvModal.hide('modal-user-register')
      this.$bvModal.show('modal-user-login')
    },
    openForgetPassword () {
      this.$router.replace('/forgetpassword')
      this.$bvModal.hide('modal-user-login')
    },
    handleSubmit (e) {
      console.log('Sign In Button Pressed')
    }
  },
  validations () {
    return {
      username: {
        required,
        validateNo: username => {
          return checkSpecialChar(username)
        }
      },
      password: {
        required,
        validateNo: username => {
          return checkSpecialChar(username)
        }
      },
      password_confirmation: {
        required,
        validateNo: username => {
          return checkSpecialChar(username)
        }
      }
    }
  }
}
</script>
